import './BrandMark.css'

/** Stella wordmark: the gold gradient tile + name and product label. */
export function BrandMark({
  subtitle = 'Skin profile',
}: {
  subtitle?: string
}) {
  return (
    <div className='brand'>
      <span className='brand__tile' aria-hidden='true' />
      <span className='brand__text'>
        <span className='brand__name'>Stella</span>
        <span className='brand__sub'>{subtitle}</span>
      </span>
    </div>
  )
}
